import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  userModal: boolean;
  groupModal: boolean;
  memberModal: boolean;
}

const initialState: UiState = {
  userModal: false,
  groupModal: false,
  memberModal: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setUserModal(state, action: PayloadAction<boolean>) {
      state.userModal = action.payload;
    },
    setGroupModal(state, action: PayloadAction<boolean>) {
      state.groupModal = action.payload;
    },
    setMemberModal(state, action: PayloadAction<boolean>) {
      state.memberModal = action.payload;
    },
  },
});

export const { setUserModal, setGroupModal, setMemberModal } = uiSlice.actions;
export default uiSlice.reducer;
